const STATIC_SPRITE_URL = "https://cdn.bicycle.ai/static-assets/icons";
export const getStaticSpriteUrl = (subUrl: string) => {
  subUrl = subUrl.startsWith("/") ? subUrl.slice(1) : subUrl;
  return `${STATIC_SPRITE_URL}/${subUrl}`;
};
